import useGetApi from 'src/api/useGetApi';

export interface ProductVariantMatchDTO {
  id: string;
  productId: string;
  attributes: Record<string, unknown>;
  variantSignature: string;
  upc: string | null;
  sku: string | null;
  originId: string | null;
  originSystem: string | null;
  originEntity: string | null;
  originMetadata: Record<string, unknown> | null;
  originAttributes: Record<string, unknown> | null;
  originAttributesSignature: string | null;
  name?: string;
  description?: string | null;
  originalId?: string | null;
  originalSystem?: string | null;
  originalEntity?: string | null;
}

interface GetFamousProductVariantMatchesResponse {
  variants: ProductVariantMatchDTO[];
}

interface QueryParams {
  originAttributes?: Record<string, unknown>;
  customerId?: string;
}

const useFamousProductVariantMatches = (
  productId = '',
  params: QueryParams,
) => {
  return useGetApi<GetFamousProductVariantMatchesResponse>({
    endpoint: `erp-integrations/famous/products/${productId}/variant-matches`,
    queryParameters: params,
    options: {
      enabled: !!productId,
    },
  });
};

export default useFamousProductVariantMatches;
